import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from "@vueuse/core";
import { TabsTrigger, useForwardProps } from "reka-ui";
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TabsTrigger',
    props: {
        value: { type: [String, Number], required: true },
        disabled: { type: Boolean, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        id: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = reactiveOmit(props, "class");
        const forwardedProps = useForwardProps(delegatedProps);
        const __returned__ = { props, delegatedProps, forwardedProps, get TabsTrigger() { return TabsTrigger; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
